<ng-template #defaultSVG>
  <svg
    class="w-4 h-4 text-gray-500 dark:text-gray-400 cursor-pointer hover:text-gray-900 dark:hover:text-white duration-300 ease-in-out"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z"
      clip-rule="evenodd"
    />
  </svg>
</ng-template>

<div
  class="relative"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <!-- Popover icon -->
  <div class="relative flex flex-col justify-center items-center">
    <div class="relative flex flex-col justify-center items-center">
      <button type="button">
        @if (customSVG()) {
          <ng-container *ngTemplateOutlet="customSVG() ?? null" />
        } @else {
          <ng-container *ngTemplateOutlet="defaultSVG" />
        }
      </button>

      <!-- Arrow -->
      <div
        class="absolute z-20 top-5 rotate-45 w-2 h-2 border-b-0 border-r-0 text-gray-500 bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
        [ngClass]="isHovered ? 'opacity-100 visible' : 'opacity-0 invisible'"
      ></div>
    </div>
    @if (isHovered) {
      <div
        id="popover-description"
        role="tooltip"
        class="absolute top-6 z-10 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-xs w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400"
        [ngClass]="{
          '-left-56': placement() === 'left',
          '-right-56': placement() !== 'left',
        }"
        animate.enter="animate-enter-down"
        animate.leave="animate-leave-down"
      >
        @if (info(); as c) {
          <div class="p-3 space-y-1">
            <h3 class="font-semibold text-gray-900 dark:text-white">
              {{ c.header }}
            </h3>
            <p
              class="font-normal text-xs 2xl:text-sm text-gray-500 dark:text-gray-300"
            >
              {{ c.body }}
            </p>
          </div>
        } @else if (useDefaultContent()) {
          <div class="p-3 space-y-2">
            <h3 class="font-semibold text-gray-900 dark:text-white">
              How to Use
            </h3>
            <ul class="space-y-2 text-gray-700 dark:text-gray-400">
              <li>
                <strong>Reset Zoom</strong>
                <p>
                  Click the
                  <img
                    class="w-4 h-4 inline"
                    src="/assets/svg/minusMagnifier.svg"
                  />
                  to return to the full graph extent
                </p>
              </li>
              <li>
                <strong>Zoom In</strong>
                <p>Click and drag anywhere on the graph to zoom in</p>
              </li>
            </ul>
          </div>
        } @else {
          <ng-content />
        }
      </div>
    }
  </div>
</div>
